export enum PasswordSections {
  EMAIL_AUTH,
  PASSWORD,
}
